import type { SliderProps } from "@mui/material/Slider";
import Stack from "@mui/material/Stack";
import { FilterBaseProps } from "../Find.types"
import { useEffect, useMemo, useState } from "react"
import { useRouter } from "next/router"
import { filterUrl } from "../Find"
import { useLayoutData } from "../../../../utils/contexts/LayoutContext"
import { PageType } from "../../../../pages/_app"
import dynamic from "next/dynamic"

const FilterSliderIntervalInteger = ({
  filters,
  pageUrl,
  mmbr,
  isMobile
}: FilterBaseProps) => {
  const router = useRouter()
  const { partnerSiteFull, templatePath } = useLayoutData()

  const [minValue, setMinValue] = useState<number | undefined>(filters?.intervalSelectedMin !== undefined ? filters?.intervalSelectedMin : undefined)
  const [maxValue, setMaxValue] = useState<number | undefined>(filters?.intervalSelectedMax !== undefined ? filters?.intervalSelectedMax : undefined)

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindSlider = useMemo(() => dynamic<SliderProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindSlider)), [path])

  const handleChangeInterval = (e: Event, newValue: number | number[]) => {
    console.log(newValue)
    if (Array.isArray(newValue)) {
      const [newMin, newMax] = newValue
      setMinValue(newMin)
      setMaxValue(newMax)
    }
  }

  const handleSearch = () => {
    let url: string | undefined
    if (minValue && minValue === filters?.intervalMin && maxValue && maxValue === filters?.intervalMax) {
      url = filters?.resetUrl
    } else {
      url = filters?.targetUrl?.replace('(min)', minValue ? minValue === filters?.intervalMin ? '' : minValue.toString() : '')
      url = url?.replace('(max)', maxValue ? maxValue === filters?.intervalMax ? '' : maxValue.toString() : '')
    }
    
    router.push(filterUrl(filters, undefined, url, pageUrl, mmbr), undefined, { scroll: false })
  }

  const generateMarks = (min: number, max: number, count: number) => {
    const diff = max - min;
    const localCount = diff <= count ? diff : count;

    if (diff <= 1) {
      return [{ value: min, label: min.toString() }, { value: max, label: max.toString() }];
    }

    const step = diff / (localCount - 1);
    if (isNaN(step) || step === 0) {
      return [];
    }
 
    return Array.from({ length: localCount }, (_, index) => ({
      value: min + step * index,
      label: (min + step * index).toFixed(0),
    }));
  };

  const marks = generateMarks(filters?.intervalMin as number, filters?.intervalMax as number, 5);

  useEffect(() => {
    setMinValue(filters?.intervalSelectedMin)
    setMaxValue(filters?.intervalSelectedMax)
  }, [filters?.intervalSelectedMin, filters?.intervalSelectedMax])

  return (
    <Stack width={'100%'} px={isMobile ? 4 : 1}>
      <FindSlider
        min={filters?.intervalMin}
        step={1}
        max={filters?.intervalMax}
        value={[minValue ?? filters?.intervalMin as number, maxValue ?? filters?.intervalMax as number]}
        onChange={handleChangeInterval}
        onChangeCommitted={() => handleSearch()}
        marks={marks}
        valueLabelDisplay={"on"}
        disabled={filters?.intervalMin === filters?.intervalMax}
        disableSwap
      />
    </Stack>
  )
}

export default FilterSliderIntervalInteger